import { render } from "./Borders.vue?vue&type=template&id=001bdf85&scoped=true"
import script from "./Borders.vue?vue&type=script&lang=js"
export * from "./Borders.vue?vue&type=script&lang=js"

import "./Borders.vue?vue&type=style&index=0&id=001bdf85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001bdf85"]])

export default __exports__